export const environment = {
  production: false,
  BASE_URL: 'https://rtis-dev-bucket.s3.ap-south-1.amazonaws.com/',
  CONSULTANT_WEB_ENDPOINT: 'https://dev.globalrtis.com/',
  SUPPLIER_WEB_ENDPOINT: 'https://dev.globalrtis.com/',
  BUYER_WEB_ENDPOINT: 'https://dev.globalrtis.com/',
  ADMIN_WEB_ENDPOINT: 'https://dev.globalrtis.com/',
  ASSOCIATION_WEB_ENDPOINT: 'https://dev.globalrtis.com/',
  AUTH_WEB_ENDPOINT: 'https://dev.globalrtis.com/',
  API_ENDPOINT: 'https://dev-rtis-api.globalrtis.com/api/v3/',
  API_ENDPOINT_AI: 'https://rtis-ai.globalrtis.com/',
  PAYMENT_API_ENDPOINT_V2: 'https://payment.globalrtis.com/',
  PAYMENT_API_ENDPOINT: 'https://staging-api.globalrtis.com/api/v1/',

  YOUTUBE_FETCH_API: 'https://www.googleapis.com/youtube/v3/playlistItems',
  YOUTUBE_API_KEY: 'AIzaSyAiK1qvdm3_hVD_yu9K479lIKkQjK3J9n0',
  YOUTUBE_MAX_RESULTS: 50,

  Google_API_Key: 'AIzaSyBpDvxXn9p14xo7fmbmpiEhLhPS5kUZdBs',
  CM_Question: '1710320790659RTIS_CM_Module-for-download_v3.pdf',

  postHogLive: false,

  POSTHOG_KEY: 'phc_S4pNREi69vkRzkO3kOFXnuTBNE4Cz9nw180iMWOVlJ8',
  POSTHOG_API_HOST: 'https://prod-api-hog.globalrtis.com',
  POSTHOG_UI_HOST: 'https://us.posthog.com',
  BCC_EMAIL: 'bcc@globalrtis.com',

  GHG_INVENTORY_LOGO: 'assets/images/logos/ghg-inventory-logo.png'
};
